import React from 'react';
import Image from 'next/image';
import { formatDate } from '@/utils/helpers';
import type { Course } from '@/types/course';

interface LiveCourseCardProps {
  course: Course;
  onClick?: () => void;
}

const LiveCourseCard: React.FC<LiveCourseCardProps> = ({ course, onClick }) => {
  return (
    <div
      className="bg-white p-4 rounded-2xl block md:flex items-center gap-4 h-full duration-300 transition-all hover:transform hover:scale-105 cursor-pointer"
      onClick={onClick}
    >
      <Image
        src={course.attributes.cover.data?.attributes.url}
        alt={course.attributes.title}
        className="w-32 h-32 rounded-tl-[12px] rounded-tr-[12px] rounded-br-[50px] rounded-bl-[12px] object-cover flex md:hidden mb-5"
        width={130}
        height={130}
      />
      <div className="flex-1 ">
        <h4 className="text-xl font-medium w-4/5 mb-2.5">{course.attributes.title}</h4>
        <p className="text-base opacity-40">{formatDate(course.attributes.date)}</p>
      </div>
      <Image
        src={course.attributes.cover.data?.attributes.url}
        alt={course.attributes.title}
        className="w-32 h-32 rounded-tl-[12px] rounded-tr-[12px] rounded-br-[12px] rounded-bl-[50px] object-cover hidden md:flex"
        width={130}
        height={130}
      />
    </div>
  );
};

export default LiveCourseCard;
